<script>
import {transactionMonitoringBankingSale as columns} from "../../../tables"

const statuses = {
  success: '#87d068',
  failed: '#f52d2dff',
}

export default {
  data() {
    return {
      columns,
      statuses,
      monitoring: true,
      transactions: [],
      enableAlert: false,
      form: this.$form.createForm(this),
      filters: {
        clients: [],
        billers: [],
        max: 30,
      }
    }
  },
  mounted() {
    this.registerListener();
  },
  methods: {
    toggleAlert() {
      this.enableAlert = !this.enableAlert
    },
    registerListener() {
      Echo.private('hyperion-monitoring-transaction-banking-sale')
        .listen('Services.Banking.Sale', (e) => this.accepted(e))
    },
    accepted(event) {
      this.loading = false

      this.transactions.unshift(event.transactionOffUs)

      if (this.transactions.length > this.filters.max)
        this.transactions.pop()
    }
  }
}
</script>

<template>
  <a-card size="small" type="inner">
    <div slot="extra">
      <a-tooltip title="Enable/Disable Alarm">
        <a-button size="small"
                  :type="enableAlert ? 'default' : 'dashed'"
                  shape="circle"
                  icon="sound"
                  @click="toggleAlert()"></a-button>
      </a-tooltip>
      <audio id="alertSound" style="display: none;" v-bind:muted="enableAlert === false">
        <source type="audio/ogg" src="/assets/audio/alert.ogg">
        <source type="audio/mp3" src="/assets/audio/alert.mp3">
      </audio>
    </div>

    <a-table :columns="columns" :dataSource="transactions" :pagination="false" :rowKey="(record, index) => `${record.time}-${record.tid}-${record.mid}-${index}`">
      <h5 slot="date" slot-scope="record">
        {{ record.date }}
      </h5>

      <h5 slot="time" slot-scope="record">
        {{ moment(record.time, 'HH:mm:ss').format('HH:mm:ss') }}
      </h5>

      <h5 slot="pan" slot-scope="record">
        {{ record.cardNumber }}
      </h5>

      <h5 slot="merchant_code" slot-scope="record">
        {{ record.merchantCode }}
      </h5>

      <div slot="type" slot-scope="record">
        <h4>
          {{ record.type }}
        </h4>
      </div>

      <h4 slot="amount" slot-scope="record">
        {{ currency(record.amount) }}
      </h4>

      <h5 slot="issuer_name" slot-scope="record">
        {{ record.issuerName }}
      </h5>

      <h5 slot="acquirer_host_type" slot-scope="record">
        {{ record.acquirerHostType }}
      </h5>

      <h5 slot="tid" slot-scope="record">
        {{ record.tid }}
      </h5>

      <h5 slot="mid" slot-scope="record">
        {{ record.mid }}
      </h5>

      <h5 slot="stan" slot-scope="record">
        {{ record.stan }}
      </h5>

      <h5 slot="rrn" slot-scope="record">
        {{ record.rrn }}
      </h5>

      <span slot="response_code" slot-scope="record" :style="{textAlign: 'center'}">
        <a-tag :color="record.responseCode === '00' ? statuses.success : statuses.failed">
          {{ record.responseCode }}
        </a-tag>
      </span>
    </a-table>
  </a-card>
</template>
